<template>
  <div>
    <el-dialog :visible.sync="show" title="开户行" :before-close="handleClose" class="boder8 resetRegister">
      <el-alert class="infoIcon mb10" :title="tips" :closable="false" show-icon></el-alert>
      <div class="resetRegister-box">
        <div>类型</div>
        <div class="align-item mt10 mb10">
          <div v-for="item in timeTypeOptions" :key="item.id" class="timeOptions br10 cur" :class="[activeCode == item.id ? 'active':'']" @click="timeChange(item.id)">{{ item.name }}</div>
        </div>
        <div class="mt20" v-show="activeCode == 'custom'">
          <div class="flex-row">
            <el-input v-model="keyword" placeholder="请输入" :maxlength="50" :clearable="true" class="inputSelect240"></el-input>
            <el-button type="primary" class="ml10" @click="querySearchAsync">搜索</el-button>
          </div>
          <div class="mt10" style="height: 170px;overflow-y: auto;" v-if="openBankOptions.length > 0">
            <div v-for="item in openBankOptions" :key="item.bankNo" class="cur bankList_item" :class="{'bankList_item_active': bankNo == item.bankno}" @click="handleSelect(item)">{{ item.bankName }}</div>
          </div>
          <div class="mt20 divCenter color999" v-else>暂无数据，请输入搜索条件查询</div>
        </div>
        <div class="mt20" v-show="activeCode == 'permanentlyValid'">
          <div class="align-item mb20">开户行：<el-input placeholder="请输入开户行" v-model.trim="subBankName" maxlength="50" class="width200"></el-input></div>
          <div class="align-item">联行号：<el-input placeholder="请致电银行客服查询开户行联行号" v-model.trim="bankNo" maxlength="12" class="width200"></el-input></div>
        </div>
        
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="btns">
          <el-button @click="handleClose">取消</el-button>
          <el-button type="primary" @click="confirm">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      openBankOptions: [],
      openBankOptionsAll: [],
      subBankName: '',
      bankNo: '',
      timeTypeOptions: [{ id: 'custom', name: '查询开户行' }, { id: 'permanentlyValid', name: '填写开户行' }],
      activeCode: 'custom',
      bankName: '',
      keyword: '',
      tips: '如仍未找到开户行，请自行填写开户行'
    }
  },
  methods: {
    open (arg) {
      this.subBankName = ''
      this.bankNo = ''
      this.keyword = ''
      this.activeCode = 'custom'
      this.bankName = arg.bankName
      this.openBankOptions = []
      this.openBankOptionsAll = []
      this.getBankList()
    },
    getBankList () {
      this.$api.get(this.$url.pingan.getBankNoList, { bankName: this.bankName + this.keyword }).then((res) => {
				if (res) {
          this.openBankOptions = res;
          this.openBankOptionsAll = res;
          this.show = true
				}
			})
    },
    fuzzyQuery (list, keyWord) {
      var reg = new RegExp(keyWord);
      var arr = [];
      for (var i = 0; i < list.length; i++) {
        if (reg.test(list[i].bankName)) {
          arr.push(list[i]);
        }
      }
      return arr;
    },
    querySearchAsync () {
      this.openBankOptions = this.fuzzyQuery(this.openBankOptionsAll, this.keyword)
    },
    handleSelect(item) {
      this.subBankName = item.bankName
      this.bankNo = item.bankno
    },
    timeChange (code) {
      if (code == 'custom') {
        this.tips = '如仍未找到开户行，请自行填写开户行'
      } else {
        this.tips = '为了避免工资发放失败，请正确填写开户行和联行号，可登录手机银行或致电银行客服查询'
      }
      this.activeCode = code
      this.subBankName = ''
      this.bankNo = ''
      this.keyword = ''
      this.openBankOptions = this.openBankOptionsAll
    },
    confirm () {
      if (!this.subBankName) {
        return this.$message.error("开户行不能为空")
      } else if (this.activeCode == 'permanentlyValid' && !this.bankNo) {
        return this.$message.error("联行号不能为空")
      }
      this.$emit('change', { subBankName: this.subBankName, bankNo: this.bankNo })
      this.show = false
    },
    handleClose () {
      this.show = false
    }
  }
}
</script>

<style scoped>
.resetRegister .resetRegister-box {
  box-sizing: border-box;
}
.infoIcon {
  color: #155BD4 !important;
  border: 1px solid #94B4EB !important;
  background-color: #EDF4FF !important;
}
.inputBorder {
  border: 1px solid #efefef;
}
.timeOptions {
  padding: 10px;
  margin-right: 10px;
  border: 1px solid #ccc;
}
.active {
  color: white;
  border-color: #1989fa;
  background-color: #1989fa;
}
.inputSelect240 {
  width: 240px;
}
.bankList_item {
  margin-bottom: 6px;
}
.bankList_item:hover {
  color: #1989fa;
}
.bankList_item_active {
  color: #1989fa;
}
</style>